<div class="review-form">
    <div class="row mg-top-12 mg-btm-20">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <p class="text-left">We always want to hear from you.  Let us know what you think we're doing well and what we <span> could be doing better.</span></p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group mg-top-10">
                <strong>Your Feedback:</strong>
                <!-- TODO: trim input -->
                <textarea class="form-control form-textarea"
                placeholder="Enter your comments here" maxlength="1500" [(ngModel)]="comments"></textarea>
                <span *ngIf="errorText" class="form-error">{{errorText}}</span>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <button type="submit" class="btn wb-btn-default center-block mg-top-18" (click)='submitFeedback()'>Submit Feedback</button>
        </div>
    </div>
</div>
